import { render } from "./SmsPricing.vue?vue&type=template&id=e91b264c"
import script from "./SmsPricing.vue?vue&type=script&lang=js"
export * from "./SmsPricing.vue?vue&type=script&lang=js"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__